interface IFavoritableOffer {
  id: number;
  isFavorite: boolean;
}

/**
 * Возвращает копию списка с изменённым флагом избранного у оффера с указанным id.
 * Если оффера в списке нет, возвращает тот же массив: редьюсер может вернуть прежний стейт.
 */
export function patchOfferFavorite<T extends IFavoritableOffer>(
  offers: T[],
  offerId: number,
  isFavorite: boolean,
): T[] {
  const offerIndex = offers.findIndex(offer => offer.id === offerId);

  if (offerIndex === -1) {
    return offers;
  }

  const nextOffers = offers.slice();
  nextOffers[offerIndex] = { ...offers[offerIndex], isFavorite };

  return nextOffers;
}
